export default "__VITE_ASSET__D7Orl9uE__"